import { Card, Divider } from 'antd';

import GenerationDefaultsSection from './GenerationDefaultsSection';
import KeyenceByProductionMethodSection from './KeyenceByProductionMethodSection';

/** Shop-wide ballooning settings. */
export default function BallooningSettingsCard() {
	return (
		<Card title="Ballooning" data-testid="ballooning-settings">
			<GenerationDefaultsSection />
			<Divider />
			<KeyenceByProductionMethodSection />
		</Card>
	);
}
